import { render, staticRenderFns } from "./TemplateFoodData.vue?vue&type=template&id=3a82267c"
import script from "./TemplateFoodData.vue?vue&type=script&lang=js"
export * from "./TemplateFoodData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports